/**
 * Datart
 *
 * Copyright 2021
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ChartConfig } from 'app/types/ChartConfig';
import { CloneValueDeep } from 'utils/object';
import BasicDoubleYConfig from '../BasicDoubleYChart/config';

const config: ChartConfig = CloneValueDeep(BasicDoubleYConfig);

config.datas = [
  {
    label: 'dimension1',
    key: 'dimension1',
    required: true,
    type: 'group',
    limit: 1,
  },
  {
    label: 'dimension2',
    key: 'dimension2',
    required: true,
    type: 'group',
    limit: 1,
  },
  {
    label: 'metricsL',
    key: 'metricsL',
    required: true,
    type: 'aggregate',
    limit: [1, 999],
  },
  {
    label: 'metricsR',
    key: 'metricsR',
    type: 'aggregate',
    limit: [0, 999],
  },
  {
    label: 'filter',
    key: 'filter',
    type: 'filter',
  },
  {
    label: 'info',
    key: 'info',
    type: 'info',
  },
  {
    label: 'colorize',
    key: 'color',
    type: 'color',
    limit: [0, 1],
  },
];

config.styles = config.styles
  ?.filter(item => !['leftYLabel', 'rightYLabel'].includes(item.key))
  .map(item => {
    if (item.key !== 'xAxis') {
      return item;
    }

    return {
      ...item,
      label: 'xAxis.title',
    };
  });

config.i18ns = config.i18ns?.map(item => {
  if (item.lang === 'zh-CN') {
    return {
      ...item,
      translation: {
        ...item.translation,
        chartName: '双X轴图',
        dimension1: '维度1',
        dimension2: '维度2',
        metricsL: '指标',
        metricsR: '指标2',
        yAxis: {
          title: 'Y轴',
        },
      },
    };
  }

  if (item.lang === 'en-US') {
    return {
      ...item,
      translation: {
        ...item.translation,
        chartName: 'Double X Chart',
        dimension1: 'Dimension 1',
        dimension2: 'Dimension 2',
        metricsL: 'Metric',
        metricsR: 'Metric 2',
        yAxis: {
          title: 'Y Axis',
        },
      },
    };
  }

  return item;
});

export default config;
